<template>
  <div>
    <div class="vx-row mt-0">
      <div class="vx-col md:w-1/3 w-full">
        <label class="vs-input--label"><b>DO Number</b></label>
        <vs-input
          v-model="doReference"
          class="w-full mt-2"
          placeholder="Enter DO Number"
        />
      </div>
    </div>

    <div class="vx-row mt-4">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label"><b>Template</b></label>
        <vs-button
          color="success"
          type="filled"
          icon="icon-download"
          icon-pack="feather"
          @click="downloadTemplate"
          :disabled="isLoadingTemplate"
          class="btn-download-success mt-2"
        >
          Download
        </vs-button>
      </div>
    </div>

    <div class="vx-row mt-4">
      <div class="vx-col md:w-1/3 w-full">
        <label class="vs-input--label"><b>File Excel</b></label>
        <div class="vs-con-input mt-2">
          <input
            type="file"
            ref="fileInput"
            accept=".xlsx,.xls"
            @change="handleFileChange"
            class="vs-input--input vs-input--input-normal"
            style="padding:6px 10px;height:38px;cursor:pointer;"
          />
        </div>
      </div>
    </div>

    <div class="vx-row mt-5">
      <div class="vx-col md:w-1/4 w-full">
        <vs-button
          color="primary"
          @click="submitUpdate"
          :disabled="!doReference || !selectedFile || isSubmitting"
        >
          Process
        </vs-button>
      </div>
    </div>

    <div class="vx-row mt-10" v-if="result">
      <div class="vx-col md:w-full w-full">
        <div style="font-size:14px;font-weight:700;margin-bottom:12px;">Hasil Update</div>
        <div style="border:1px solid #ddd;border-radius:4px;overflow:hidden;">
          <div class="vx-row" style="border-bottom:1px solid #ddd;background:#e8e8e8;">
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:14px;font-weight:600;">DO REFERENCE</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:14px;font-weight:600;">ROWS PROCESSED</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:14px;font-weight:600;">DO DETAILS UPDATED</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:14px;font-weight:600;">TRANSACTIONS UPDATED</span>
            </div>
          </div>
          <div class="vx-row" style="background:#fff;">
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:14px;">{{ result.do_reference }}</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:14px;">{{ result.rows_processed }}</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:14px;">{{ result.do_details_updated }}</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:14px;">{{ result.transactions_updated }}</span>
            </div>
          </div>
          <div class="vx-row" style="border-top:1px solid #ddd;background:#f8f8f8;">
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Inventories Updated: </span>
              <span style="font-size:14px;">{{ result.inventories_updated }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChangeSerialNumberGiTwh",
  data() {
    return {
      doReference: "",
      selectedFile: null,
      isSubmitting: false,
      isLoadingTemplate: false,
      result: null,
    };
  },
  methods: {
    downloadTemplate() {
      this.isLoadingTemplate = true;

      this.$http
        .get("support/inbound/gr/pack/template", {
          responseType: "blob",
        })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "template_change_pack_id.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Template berhasil didownload.",
          });
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.isLoadingTemplate = false;
        });
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const validTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];
      if (!validTypes.includes(file.type)) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "File harus berformat .xlsx atau .xls",
        });
        this.selectedFile = null;
        this.$refs.fileInput.value = "";
        return;
      }

      this.selectedFile = file;
      this.result = null;
    },

    submitUpdate() {
      const doReference = this.doReference.trim();
      if (!doReference || !this.selectedFile) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "DO Number dan file Excel wajib diisi",
        });
        return;
      }

      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: "Konfirmasi",
        text: `Apakah kamu yakin ingin mengubah serial number untuk DO ${doReference}?`,
        acceptText: "Ya, Process",
        accept: () => {
          this.processUpdate(doReference);
        },
      });
    },

    processUpdate(doReference) {
      this.isSubmitting = true;
      const formData = new FormData();
      formData.append("do_reference", doReference);
      formData.append("file", this.selectedFile);

      this.$http
        .post("support/outbound/deliveryorder/change-pack-id", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.result = res.data.data;
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: res.data.message || "Serial Number berhasil diupdate.",
          });
          this.selectedFile = null;
          this.$refs.fileInput.value = "";
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>

<style>
.btn-download-success .vs-button-background,
.btn-download-success:hover .vs-button-background {
  background: #5cb85c !important;
}
.btn-download-success .vs-button-text,
.btn-download-success:hover .vs-button-text {
  color: #fff !important;
}
.btn-download-success i,
.btn-download-success:hover i {
  color: #fff !important;
}
</style>
